import styled from '@emotion/styled';
import {Button} from '@mui/joy';

export const CardPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.sm};
`;

export const CardPaymentTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CardPaymentTopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.md};
`;

export const CardPaymentBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${({theme}) => theme.gap.desktop.sm};
`;

export const CardPaymentBottomLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.gap.desktop.lg};
`;

export const CardPaymentBottomLeftItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xs};
`;

export const DeferButton = styled(Button)`
  min-width: 104px;
  min-height: 40px;
  border-radius: ${({theme}) => theme.border.radius.xxs};
`;
